import React from "react";

class Speaker1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Keynote Speakers - 21st International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Keynote Speaker</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <div className="col-xl-12 col-md-12">
                      <img
                        src={require("../assets/img-comm/fernando_new.PNG")}
                        alt=""
                        width="200"
                        height="270"
                      />
                      <h4>Dr Fernando Moreira </h4>

                      <div className="organiser_intro mt-2 col-md-12">
                        <div className="col-md-12">
                          <p align="center">
                            <i>
                              Professor, Portucalense University, Porto,
                              Portugal
                            </i>
                          </p>
                        </div>
                      </div>
                      <br></br>
                      <div className="intro_left_content text_left">
                        <p align="left">
                          Dr. Fernando Moreira is a Full Professor, Department
                          of Science and Technolgy, Portucalense University,
                          Porto, Portugal
                        </p>
                        <p align="left">
                          Fernando Moreira established the Science and
                          Technology Department, created the first engineering
                          degrees, and served as its head from May 2018 until
                          February 2022. He earned his Bachelor's degree in
                          Computer Science in 1992, a Master's degree in
                          Electronic Engineering in 1997, and a PhD in
                          Electronic Engineering in 2003, all from the Faculty
                          of Engineering at the University of Porto. In 2018, he
                          also achieved his Habilitation. He has been a member
                          of the University since 1992 and currently holds the
                          position of Full Professor. Additionally, he serves as
                          a visiting professor at several other esteemed
                          universities. His teaching portfolio encompasses a
                          range of subjects across undergraduate and
                          postgraduate studies. He also supervises PhD and
                          Master's students. He has made significant
                          contributions to his field, with over 345
                          peer-reviewed, Scopus-indexed scientific publications
                          in national and international journals and
                          conferences. He serves on the Editorial Advisory Board
                          for several journals and books. He has organised
                          numerous special issues for JCR journals (Telematics
                          and Informatics, Future Generation Computer Systems,
                          Cluster Computing, Expert Systems, etc.). His
                          commitment to advancing research is reflected in his
                          consistent participation as Conference Chair, Workshop
                          Chair, Chief Guest, and Keynote speaker, as well as on
                          the programme and scientific committees of national
                          and international conferences. He served as the MSc in
                          Computation coordinator for a decade, demonstrating
                          his dedication to academic leadership. He is a member
                          of the REMIT research centre steering committee, with
                          extensive editorial experience and a track record of
                          co-editing several books. His professional
                          affiliations include NSTICC, ACM, and IEEE. His
                          primary research interests include mobile computing,
                          AI in higher education, Machine Learning, and Digital
                          transformation. He received the prestigious Atlas
                          Elsevier Award in April 2019 for his contributions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Speaker1;
